export const STATUS_ALL_OPEN = 'All Open';
export const STATUS_ALL_CLOSED = 'All Closed';
export const STATUS_SPECIAL_CASES = [STATUS_ALL_OPEN, STATUS_ALL_CLOSED];
